import api from '../api/axios'

const getAllAppointments = (date, id, forQueue) => {
  const response = api.get(
    `/appointment?skip=0&take=1000000&sort=deletedAt%2Cdesc&sort=id%2Casc&withDeleted=false${
      date ? `&date=${date}` : ''
    }${id ? `&userId=${id}` : ''}${forQueue ? '&forQueue=true' : ''}&withDayOff=true`,
  );

  return response
}

const getAppointmentById = (id) => {
  const response = api.get(`/appointment/${id}`)

  return response
}

const create = (appointment) => {
  const response = api.post(`/appointment`, appointment)

  return response
}

const update = (id, updatedAppointment) => {
  const response = api.patch(`/appointment/${id}`, updatedAppointment)

  return response
}

const remove = (id) => {
  const response = api.delete(`/appointment/${id}`)

  return response
}

const getAppointmentTypes = (withDeleted = true) => {
  const response = api.get(
    `/appointmentType?skip=0&take=1000000&sort=deletedAt%2Cdesc&sort=id%2Casc&withDeleted=${withDeleted}`,
  )

  return response
}

const getAppointmentTypeById = (id) => {
  const response = api.get(`/appointmentType/${id}`)

  return response
}

const createAppointmentType = (name) => {
  const response = api.post(`/appointmentType`, {
    name,
  })

  return response
}

const removeAppointmentType = (id) => {
  const response = api.delete(`/appointmentType/${id}`)

  return response
}

const restoreAppointmentType = (id) => {
  const response = api.get(`/appointmentType/${id}/restore`)

  return response
}

const getAppointmentSources = (withDeleted = true) => {
  const response = api.get(
    `/appointmentSource?skip=0&take=1000000&sort=deletedAt%2Cdesc&sort=id%2Casc&withDeleted=${withDeleted}`,
  )

  return response
}

const createAppointmentSource = (name) => {
  const response = api.post(`/appointmentSource`, {
    name,
  })

  return response
}

const removeAppointmentSource = (id) => {
  const response = api.delete(`/appointmentSource/${id}`)

  return response
}

const restoreAppointmentSource = (id) => {
  const response = api.get(`/appointmentSource/${id}/restore`)

  return response
}


// Get appointments for a property (lightweight, for history)
const getByProperty = (propertyId, take = 20, skip = 0) => {
  return api.get(`/appointment/by-property/${propertyId}?take=${take}&skip=${skip}`);
};

// Global address search across all dates (history modal)
const searchByAddress = (q, take = 100) => {
  return api.get(`/appointment/search-by-address?q=${encodeURIComponent(q)}&take=${take}`);
};

const appointmentsServices = {
  getByProperty,
  searchByAddress,
  getAllAppointments,
  getAppointmentById,
  create,
  update,
  remove,
  getAppointmentTypes,
  createAppointmentType,
  getAppointmentTypeById,
  removeAppointmentType,
  restoreAppointmentType,
  getAppointmentSources,
  createAppointmentSource,
  removeAppointmentSource,
  restoreAppointmentSource,
}

export default appointmentsServices

const getAppointmentsByDateRange = (startDate, endDate) => {
  const response = api.get(
    `/appointment?skip=0&take=1000000&sort=startTime%2Casc&withDeleted=false&startDate=${startDate}&endDate=${endDate}&withDayOff=true`,
  );

  return response;
};

appointmentsServices.getAppointmentsByDateRange = getAppointmentsByDateRange;

// Get cancelled appointments by date
const getCancelledAppointments = (date) => {
  const response = api.get(
    `/appointment?skip=0&take=1000000&sort=createdAt%2Cdesc&withDeleted=false${
      date ? `&date=${date}` : ''
    }&status=Cancelled`,
  );
  return response;
};

// Get cancelled appointments by date range (for week/month views)
const getCancelledAppointmentsByDateRange = (startDate, endDate) => {
  const response = api.get(
    `/appointment?skip=0&take=1000000&sort=startTime%2Casc&withDeleted=false&startDate=${startDate}&endDate=${endDate}&status=Cancelled`,
  );
  return response;
};

// Restore cancelled appointment to queue
const restoreToQueue = (id) => {
  const response = api.patch(`/appointment/${id}`, {
    status: 'Active',
    user: { id: null },
    startTime: null,
    endTime: null,
  });
  return response;
};

appointmentsServices.getCancelledAppointments = getCancelledAppointments;
appointmentsServices.getCancelledAppointmentsByDateRange = getCancelledAppointmentsByDateRange;
appointmentsServices.restoreToQueue = restoreToQueue;

// Technicians (or salesmen) ranked by driving time to this appointment's address
appointmentsServices.getNearestTechnicians = (id, limit = 5, kind = 'technician') =>
  api.get(`/appointment/${id}/nearest-technicians?limit=${limit}&kind=${kind}`);

appointmentsServices.resetCheckIn = (id) => api.patch(`/appointment/${id}/reset-checkin`);
appointmentsServices.resetCheckOut = (id) => api.patch(`/appointment/${id}/reset-checkout`);
